<template>
  <v-row>
    <v-col cols="12">
      <div class="d-flex">
        <div class="d-inline-flex my-auto">
          <h2
            :class="titleClass"
            style="line-height: initial;"
          >
            {{ title.toLocaleUpperCase($i18n.locale) }}
          </h2>
        </div>

        <v-spacer />

        <div class="d-inline-flex my-auto">
          <v-btn
            :disabled="!hasPrev"
            class="mx-1 brand-beige"
            color="brand-green-dark"
            icon
            small
            @click="onAffixClick('prev')"
          >
            <v-icon color="brand-green-dark">
              mdi-chevron-left
            </v-icon>
          </v-btn>

          <v-btn
            :disabled="!hasNext"
            class="mx-1 brand-beige"
            color="brand-green-dark"
            icon
            small
            @click="onAffixClick('next')"
          >
            <v-icon color="brand-green-dark">
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </div>
      </div>
    </v-col>

    <v-col cols="12">
      <v-slide-group
        ref="categoriesSlideGroup"
        class="categories-slider-group"
        show-arrows="always"
      >
        <v-slide-item
          v-for="(store, idx) in storesFiltered"
          :key="`category-${idx}`"
        >
          <div
            :style="`width: ${cardWidth}px;`"
            class="mr-1 mb-1 pa-1 brand-beige"
          >
            <brand-card
              :dense="dense"
              :item="store"
              hover
              @click="onItemClick(store)"
            />
          </div>
        </v-slide-item>
      </v-slide-group>
    </v-col>
  </v-row>
</template>

<script>
import BrandSliderMixin from '@/theme/default/views/home/BrandSlider.js'

export default {
  name  : 'BrandSlider',
  mixins: [BrandSliderMixin]
}
</script>

<style scoped src="@/theme/default/views/home/BrandSlider.css"></style>
<style scoped>
</style>
